import CardCollection from './CardCollection';
import TxpStyle from 'txp-data/lib/schema/viewSchema/TxpStyle';
import * as React from 'react';
import { TxpObject } from 'txp-data';
import TxpConfiguration from 'txp-data/lib/schema/configSchema/TxpConfiguration';
import TxpStrings from 'txp-data/lib/schema/configSchema/TxpStrings';
import populateViewCards from 'txp-data/lib/utils/view/PopulateViewCards';

let styles = require('./Txp.scss');
let classNames = require('classnames/bind');
let viewData;

export interface TxpProps extends React.HTMLProps<HTMLDivElement> {
    txpStyle: TxpStyle;
    txpStrings: TxpStrings;
    txpObject?: TxpObject;
    calendarEventIds?: any[];
    txpConfiguration: TxpConfiguration;
}

export default class Txp extends React.Component<TxpProps, {}> {
    render() {
        let {
            txpObject,
            className,
            calendarEventIds,
            txpStyle,
            txpStrings,
            txpConfiguration,
        } = this.props;

        classNames = classNames.bind(styles);

        if (txpObject) {
            viewData = populateViewCards(
                txpObject,
                calendarEventIds,
                !!txpConfiguration.getLocationControl,
                txpStrings,
                txpConfiguration.txpImages,
                txpConfiguration.cardRole
            );
        }
        let cards = viewData ? viewData.cardItems : null;
        let isBusStopEnabled = viewData ? viewData.isBusStopEnabled : null;
        if (cards) {
            return (
                <div className={classNames([className])}>
                    <CardCollection
                        cardItems={cards}
                        isBusStopEnabled={isBusStopEnabled}
                        txpStyle={txpStyle}
                        txpConfiguration={txpConfiguration}
                        strings={txpStrings.strings}
                    />
                </div>
            );
        } else {
            return null;
        }
    }
}
